import { createContext } from 'react';

interface Context {
  drawerOpen: boolean;
  openDrawer: (drawerName: string) => void;
  closeDrawer: () => void;
  setDrawer: (drawerName: string) => void;
  selectedDrawer: string;
}

export default createContext<Context>({
  drawerOpen: false,
  openDrawer: () => {},
  closeDrawer: () => {},
  setDrawer: () => {},
  selectedDrawer: '',
});
